module.exports = __webpack_public_path__ + "static/beach2-b75562776ccdac5501fe57f446c01bc3.mp4";